import React, { useState } from 'react';
import { useTestAB } from '@catalogo/core-experiments';
import { Component, ProductConditionsProps, Condition, inSkusHasConditionOfType } from '../helpers/product-condiction';

export const withProductCondition: Component = Component => props => {
  const currentCondition = props?.currentCondition?.toLowerCase() as Condition;
  const [conditionSelected, setConditionSelected] = useState<Condition>(currentCondition ?? 'new');
  const hasNew = inSkusHasConditionOfType(props.conditions, 'new');
  const hasRewrapped = inSkusHasConditionOfType(props.conditions, 'rewrapped');
  const onlyNew = hasNew && !hasRewrapped;
  const onlyRewrapped = !hasNew && hasRewrapped;
  const showAlert = conditionSelected === 'rewrapped' || onlyRewrapped;
  const override = onlyNew ? 'control' : undefined;
  const experiment = useTestAB('EXP_CAT_PRODUCT_CONDITIONS', override);

  if (onlyNew || experiment?.toLowerCase() !== 'new') {
    return null;
  }

  const componentProps: ProductConditionsProps = {
    showAlert,
    onlyRewrapped,
    conditionSelected,
    setConditionSelected,
    parsedQs: props.parsedQs,
    history: props.history,
  };

  return <Component {...componentProps} />;
};

export default withProductCondition;
